import { WebGLRenderTarget } from "three";

const renderTargets = {
  background: new WebGLRenderTarget(1024, 1024, { stencilBuffer: false }),
};

export default renderTargets;
